export const VehicleRegisterAction = {
  SelectedVehicleDetailsIndex: 'selectedVehicleDetailsId'
}
